import * as React from 'react';

// Components
import { Link } from 'components/link';

// Config
import { choosePlan } from 'config/routes';

// Modules
import { DI } from 'modules';

const DownloadSliderChoosePlan = ({ common }) => {
  const { strings } = common;

  const rootCln = 'side-buy-plan';
  const prefix = 'page.video.slider';

  return (
    <>
      <div className="side-popup-line" />

      <div className={`${rootCln}__text ${rootCln}__text--padded`}>
        {strings[`${prefix}.one_off_info`]}
      </div>

      <Link className={`${rootCln}__btn btn-bord`} to={choosePlan.getPath()}>
        {strings[`${prefix}.choose_plan`]}
      </Link>
    </>
  );
};

export default DI(['common'])(DownloadSliderChoosePlan);
